import Phaser from 'phaser'
import ScoreLabel from '../ui/ScoreLabel'
import LifeLabel from '../ui/LifeLabel.js'
var platforms
var player
var cursors
var enemy1
var enemy2
var enemy3
var enemy4
var enemy5
var enemy6 
var enemy7 
var enemy8 
var enemy9 
var enemy10
var enemy11
var enemy12
var enemy13
var enemy14
var enemy15 
var enemy16
var enemy17
var enemy18

export default class ReoMathematicsScene extends Phaser.Scene
{ 
    constructor()
    { 
        super ('reo-mathematics-scene')
    }
    
    init(data)
    { 
        this.gameHalfWidth = this.scale.width * 0.5 
        this.gameHalfHeight = this.scale.height * 0.5 

        this.score = data.score

        this.totalEnemy= data.totalEnemy 

        this.enemyArray=data.enemyArray?data.enemyArray:[]

        this.allEnemy =[]

        this.flag= undefined
        
        this.lifeLabel = data.lifeLabel?data.lifeLabel:0

        this.playerCoordinate = data.playerCoordinate?data.playerCoordinate:{x: null, y: null}

        this.count = 0
    }


    preload() 
    { 
        this.load.spritesheet ('player', 'images/player.png', 
            { frameWidth: 32, frameHeight: 32 } )
        this.load.spritesheet ('platform', 'images/platform.png',
             { frameHeight: 64 ,frameWidth: 192, startFrame: 3 , endFrame: 5 })
        this.load.image ('background', 'images/sky.png')
        this.load.image ('cloud', 'images/cloud.png')
        this.load.image ('platforms', 'images/platforms.png')
        this.load.spritesheet ('enemy', 'images/enemy.png', 
            { frameWidth: 32, frameHeight: 32})
        this.load.spritesheet ('flag', 'images/flag.png', 
            {frameWidth: 60, frameHeight:60})
        this.load.audio ('jump', 'sfx/jump.wav')
        this.load.audio ('youwin', 'sfx/youwin.wav')
        this.load.audio ('backsound', 'sfx/back.wav')
    
    }


    create() 
    {   
        this.backsound = this.sound.add ('backsound')
        var soundConfig= { 
            loop : true
        }
        this.backsound.play(soundConfig)


        this.add.image (this.gameHalfWidth, this.gameHalfHeight, 'background').setScale(2)
        
        this.clouds = this.physics.add.staticGroup ( { 
            key : 'cloud',
            repeat: 50
        })
        Phaser.Actions.RandomRectangle (this.clouds.getChildren(), this.physics.world.bounds);
        platforms = this.physics.add.staticGroup() 

        platforms.create (700, 820, 'platforms'). setScale(4).refreshBody()
        platforms.create (1350, 650, 'platform')
        platforms.create (1250, 520, 'platform')
        platforms.create (1150, 390, 'platform')
        platforms.create (1200, 260, 'platform')
        platforms.create (1300, 130, 'platform')
        platforms.create (1100, 700, 'platform')
        platforms.create (1000, 570, 'platform')
        platforms.create (900, 440, 'platform')
        platforms.create (800, 310, 'platform')
        platforms.create (970, 200, 'platform')
        platforms.create (800, 100, 'platform')
        platforms.create (230, 700, 'platform')
        platforms.create (380, 570, 'platform')
        platforms.create (540, 440, 'platform')
        platforms.create (400, 310, 'platform')
        platforms.create (270, 200, 'platform')
        platforms.create (140, 120, 'platform')
        platforms.create (60, 470, 'platform')

        this.flag = this.physics.add.sprite(170, 56, 'flag')
            this.physics.add.collider(this.flag, platforms)

        enemy1 = this.physics.add.sprite (1350, 586, 'enemy').setScale(2)
            this.physics.add.collider (enemy1, platforms)
        enemy2 = this.physics.add.sprite (1250, 456, 'enemy').setScale(2)
            this.physics.add.collider (enemy2, platforms)
        enemy3= this.physics.add.sprite (1150, 326, 'enemy').setScale(2)
            this.physics.add.collider (enemy3, platforms)
        enemy4= this.physics.add.sprite (1200, 196, 'enemy').setScale(2)
            this.physics.add.collider (enemy4, platforms)
        enemy5= this.physics.add.sprite (1300, 66, 'enemy').setScale(2)
            this.physics.add.collider (enemy5, platforms)
        enemy6= this.physics.add.sprite (1100, 636, 'enemy').setScale(2)
            this.physics.add.collider (enemy6, platforms)
        enemy7= this.physics.add.sprite (1000, 506, 'enemy').setScale(2)
            this.physics.add.collider (enemy7, platforms)
        enemy8= this.physics.add.sprite (900, 376, 'enemy').setScale(2)
            this.physics.add.collider (enemy8, platforms)
        enemy9= this.physics.add.sprite (800, 246, 'enemy').setScale(2)
            this.physics.add.collider (enemy9, platforms)
        enemy10= this.physics.add.sprite (970, 136, 'enemy').setScale(2)
            this.physics.add.collider (enemy10, platforms)
        enemy11= this.physics.add.sprite (800, 36, 'enemy').setScale(2)
            this.physics.add.collider (enemy11, platforms)
        enemy12= this.physics.add.sprite (230, 636, 'enemy').setScale(2)
            this.physics.add.collider (enemy12, platforms)
        enemy13= this.physics.add.sprite (380, 506, 'enemy').setScale(2)
            this.physics.add.collider (enemy13, platforms)
        enemy14= this.physics.add.sprite (540, 376, 'enemy').setScale(2)
            this.physics.add.collider (enemy14, platforms)
        enemy15= this.physics.add.sprite (400, 246, 'enemy').setScale(2)
            this.physics.add.collider (enemy15, platforms)
        enemy16= this.physics.add.sprite (270, 136, 'enemy').setScale(2)
            this.physics.add.collider (enemy16, platforms)
        enemy17= this.physics.add.sprite (60, 406, 'enemy').setScale(2)
            this.physics.add.collider (enemy17, platforms)
        
        this.allEnemy.push(
            enemy1, 
            enemy2, 
            enemy3,
            enemy4, 
            enemy5, 
            enemy6, 
            enemy7, 
            enemy8,
            enemy9,
            enemy10, 
            enemy11, 
            enemy12, 
            enemy13, 
            enemy14, 
            enemy15, 
            enemy16, 
            enemy17
        )
        

        player = this.physics.add.sprite (this.playerCoordinate.x?this.playerCoordinate.x:100, 
                    this.playerCoordinate.y?this.playerCoordinate.y:500, 'player').setScale(2)
        player.setCollideWorldBounds (true)
        this.physics.add.collider (player, platforms, this.suara, undefined, this)
       
       
        
        

        this.physics.add.overlap(
            player, 
            enemy1, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy2, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy3, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy4, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy5, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy6, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy7, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy8, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy9, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy10, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy11, 
            this.playerOverlapEnemy,
            null, 
            this
            )
            this.physics.add.overlap(
            player, 
            enemy12, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy13, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy14, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy15, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy16, 
            this.playerOverlapEnemy,
            null, 
            this
            )
        this.physics.add.overlap(
            player, 
            enemy17, 
            this.playerOverlapEnemy,
            null, 
            this
        )
            
        this.anims.create ({ 
            key : 'left', 
            frames: this.anims.generateFrameNumbers ('player', 
                { start: 3, end: 5}), 
            frameRate: 10, 
            repeat: -1
        })
        this.anims.create ({ 
            key : 'right', 
            frames: this.anims.generateFrameNumbers ('player', 
                { start: 6, end: 8}), 
            frameRate: 10, 
            repeat: -1
        })
        this.anims.create ({ 
            key : 'turn', 
            frames: [ { key: 'player', frame: 0}],
            frameRate: 10, 
            repeat: -1
        })
        this.anims.create ({ 
            key : 'jump', 
            frames: this.anims.generateFrameNumbers ('player', 
                { start: 9, end: 11}), 
            frameRate: 10, 
            repeat: -1
        })

        cursors= this.input.keyboard.createCursorKeys()

        this.scoreLabel = this.createScoreLabel (26,16,this.score?this.score:0)
        this.lifeLabel= this.createLifeLabel(26, 40, this.lifeLabel?this.lifeLabel:3)


        //this.add.text(26, 16, 'SCORE:', { fontSize:
            // @ts-ignore
            //'24px', fill: '#000'})

        //this.add.text(150, 16, this.score, { fontSize:
            // @ts-ignore
            //'24px', fill: '#000'})

        this.physics.add.overlap( 
            player,
            this.flag, 
            this.playerOverlapFlag, 
            undefined, 
            this
        )

    }

    update() 
    { 
        if (cursors.left.isDown) { 
            player.setVelocityX(-160)
            player.anims.play ('left', true)
        }
        else if (cursors.right.isDown){ 
            player.setVelocityX(160)
            player.anims.play('right', true)
        }
        else if(cursors.up.isDown){ 
            player.setVelocityY(-250)
            player.anims.play('jump')
        }
        else { 
            player.setVelocityX(0)
            player.anims.play('turn')
        }

        if (this.enemyArray.length !==0){
            for (let i = 0; i < this.enemyArray.length; i++){
               for (let j = 0; j < this.allEnemy.length; j++){ 
                   if((this.allEnemy[j].x === this.enemyArray[i].x) && (this.allEnemy[j].y === this.enemyArray[i].y)){
                       this.allEnemy[j].destroy()
                   }
               } 
            }
        }

        if (!player.body.touching.down)
        { 
            this.count = 0
        }

    }

    createScoreLabel (x, y, score)
    { 
        const style = {fontSize: '24px', fill: '#000', fontStyle: 'bold'}
        const label = new ScoreLabel (this, x, y, score, style).setDepth(1)

        this.add.existing (label)
        return label
    }

    playerOverlapEnemy(player, enemy) 
    { 
        enemy.destroy()
        this.enemyArray.push({
            x: enemy.x, 
            y: enemy.y
        })
        this.playerCoordinate.x = player.x 
        this.playerCoordinate.y = player.y
        //console.log(JSON.stringify(this.playerCoordinate)+'hahah')
        console.log(JSON.stringify(this.enemyArray)+"yuhu")
        this.sound.stopAll()
        this.scene.start('soal-scene',  
            { score: this.scoreLabel.getScore(), lifeLabel: this.lifeLabel.getLife(),
            enemyArray: this.enemyArray,playerCoordinate: this.playerCoordinate})
    }
    
    playerOverlapFlag(player, flag)
    { 
        if (this.scoreLabel.getScore() > 50)
        {
            this.sound.stopAll()
            this.sound.play ('youwin')
            this.scene.start('you-win-scene', { score: this.scoreLabel.getScore()})
        }
    }

    createLifeLabel(x, y, life)
    {
        const style = { fontSize: '24px', fill: '#000', fontStyle: 'bold'}
        const label = new LifeLabel (this, x, y, life, style).setDepth(1)

        this.add.existing(label)

        return label 
    }

    suara (player, platform)
    { 
        this.count++
        if (this.count === 1 && player.body.touching.down)
        { 
            this.sound.play ('jump')
        }
    }
}